import { useSearchParams } from "react-router-dom";

const useQuery = (): { [key: string]: string } => {
    const [searchParams] = useSearchParams();
    return Object.fromEntries([...searchParams]);
};

export default useQuery;
